import AppEntry from '@root/agents.joinroot.com/src/app-entry';
import ErrorReportService from '@root/core/src/services/error-report-service';
import React from '@root/vendor/react';
import ReactDOM from '@root/vendor/react-dom';
import environment from '@root/core/src/utils/environment';
import { BrowserRouter } from '@root/vendor/react-router-dom';

function renderApp() {
  ReactDOM.render(
    <AppEntry routerComponent={BrowserRouter} />,
    document.getElementById('root')
  );
}

if (!Object.entries || !window.URLSearchParams) {
  // Unsupported browser (cannot run the app bundle) — redirect to the marketing site.
  // Mirrors quote/renters/bind; replaces the former inline browser-check <script> in
  // index.html so the page no longer needs script-src 'unsafe-inline' (BILLPAY-468).
  // eslint-disable-next-line root/prevent-use-of-window-location
  window.location.replace(`${environment.websiteBaseUrl}/app/`);
} else {
  ErrorReportService.init({
    environment,
    options: { normalizeDepth: 5 },
  });

  renderApp();
}
